import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 240.49 143.18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <path d="M195.31,143.18H41.87C18.78,143.18,0,124.39,0,101.3s18.78-41.87,41.87-41.87c2.27,0,4.54.18,6.78.55,7.31-23.83,29.24-40.2,54.47-40.2,21.41,0,41.06,12.11,50.75,31.07,1.43-.14,2.86-.21,4.27-.21,23.19,0,42.45,18.13,44.19,40.95,11.3,3.1,19.23,13.33,19.23,25.31,0,14.48-11.78,26.27-26.27,26.27ZM41.87,66.43c-19.23,0-34.87,15.64-34.87,34.87s15.64,34.88,34.87,34.88h153.43c10.62,0,19.27-8.64,19.27-19.27,0-9.5-6.8-17.5-16.17-19.01-1.68-.27-2.92-1.71-2.94-3.41-.26-20.31-17-36.84-37.32-36.84-1.92,0-3.87.15-5.8.45-1.55.24-3.07-.58-3.72-2.01-8.1-17.8-25.97-29.31-45.51-29.31-23.12,0-43.09,15.67-48.56,38.11-.22.9-.79,1.68-1.59,2.17-.8.48-1.75.63-2.66.4-2.75-.69-5.59-1.03-8.44-1.03Z" />
        <path d="M225.62,98.3c-1.03,0-2.04-.45-2.73-1.31-1.21-1.51-.97-3.71.54-4.92,6.39-5.12,10.06-12.75,10.06-20.94,0-14.79-12.03-26.83-26.83-26.83-1.4,0-2.81.11-4.18.33-.94.15-1.89-.09-2.65-.66-.76-.57-1.25-1.42-1.37-2.36-2.51-19.74-19.43-34.62-39.35-34.62-10.86,0-21,4.3-28.54,12.11-1.34,1.39-3.56,1.43-4.95.09-1.39-1.34-1.43-3.56-.09-4.95,8.88-9.19,20.8-14.25,33.58-14.25,22.29,0,41.38,15.83,45.74,37.35.6-.03,1.21-.05,1.81-.05,18.65,0,33.83,15.17,33.83,33.83,0,10.32-4.62,19.94-12.68,26.4-.65.52-1.42.77-2.19.77Z" />
      </g>
    </svg>
  )
}
export default Icon
